export const SESSION_STORAGE_KEY = "oxford-favourite-vehicle";
export const storePreAuthFavourite = (metadata)=>{
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(metadata));
};
